import API from "@lib/api";
import { QueryUtils } from "@utils";
import { IModule, Messages, IPermissions } from "@interfaces";

import { BaseApi } from "./base-api";

export class ModulesApi extends BaseApi {
  protected static api = API({ namespace: "Modulo" });
  protected static messages: Messages<typeof ModulesApi> = {};

  public static async getAll() {
    const modules = await this.api.get<IModule[]>("GetAll");
    return modules.data;
  }

  public static async getPermissions(data: {
    RolId: number;
    ModuloId: number;
  }) {
    const permissions = await this.api.get<IPermissions[]>(
      `GetPermisos${QueryUtils.filter(data)}`,
    );
    return permissions.data;
  }
}
